import { render, staticRenderFns } from "./PurchaseinReport.vue?vue&type=template&id=582a8bfe"
import script from "./PurchaseinReport.vue?vue&type=script&lang=js"
export * from "./PurchaseinReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports